import React from 'react';
import { AlertCircle, WifiOff, RefreshCw } from 'lucide-react';
import { AppError } from '../hooks/useAudioRecording';

interface ErrorDisplayProps {
  error: AppError | null;
  isConnected: boolean;
  onRetry: () => void;
}

export function ErrorDisplay({ error, isConnected, onRetry }: ErrorDisplayProps) {
  if (!error && isConnected) return null;

  // Show WebSocket connection warning
  if (!isConnected && !error) {
    return (
      <div className="mb-4 warning-container p-3">
        <div className="flex items-start space-x-2">
          <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center">
            <WifiOff className="w-3 h-3 text-white" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-orange-100">Connection Issue</h4>
            <p className="text-xs text-orange-200">Reconnecting to service...</p>
            <button
              onClick={onRetry}
              className="mt-2 text-xs text-orange-100 hover:text-white underline"
            >
              Retry connection
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show error
  if (error) {
    return (
      <div className="mb-4 error-container p-3">
        <div className="flex items-start space-x-2">
          <div className="w-6 h-6 rounded-full bg-red-500 flex items-center justify-center">
            <AlertCircle className="w-3 h-3 text-white" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-red-100">
              {error.type === 'audio' ? 'Audio Error' : 
               error.type === 'network' ? 'Connection Error' : 
               error.type === 'api' ? 'Service Error' : 'Error'}
            </h4>
            <p className="text-xs text-red-200 break-words">{error.message}</p>
            {error.retryable && (
              <button
                onClick={onRetry}
                className="mt-2 flex items-center space-x-1 text-xs text-red-100 hover:text-white"
              >
                <RefreshCw className="w-3 h-3" />
                <span>Try again</span>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
} 